import { ISelectOption }  from '@typings/components';
import {
  ISalesPersonDataByType,
}                         from '@typings/accountManagement';
import { EUserRole }      from '@enums/common';
import {
  EAccountStatus,
  EPartnersStateType,
}                         from '@enums/accountManagement';
import {
  EFeeType,
  EFeeUserType,
}                         from '@enums/invoiceManagement';

export const accountStatusOptions: ISelectOption[] = [
  { label: 'Active',             value: EAccountStatus.Active },
  { label: 'Canceled',           value: EAccountStatus.Cancelled },
  { label: 'Prospect',           value: EAccountStatus.Prospect },
  { label: 'Reviewing Contract', value: EAccountStatus.ReviewingContract },
];

export const PARTNERS_TITLE: Record<EPartnersStateType, string> = {
  [EPartnersStateType.SRS]                : 'SRS - Recoveries and Remarketing',
  [EPartnersStateType.ER]                 : 'Express Recoveries',
  [EPartnersStateType.CarFaxAuth]         : 'CARFAX authorization',
  [EPartnersStateType.CarFaxActivate]     : 'CARFAX activation',
  [EPartnersStateType.DealerOnly]         : 'Dealer Only',
  [EPartnersStateType.JDPower]            : 'J.D. Power',
  [EPartnersStateType.DeficiencyTracking] : 'Deficiency Tracking',
  [EPartnersStateType.VRM]                : 'VRM - Location Services',
  [EPartnersStateType.Reindeer]           : 'Reindeer - Auto Relocation',
};

export const SALESPERSON_DATA_BY_TYPE: Record<string, ISalesPersonDataByType> = {
  monthlyFees: {
    pricingKey  : 'monthlyFee',
    type        : EFeeType.Monthly,
    feeUserType : EFeeUserType.Other,
  },
  personalAdministrationFee: {
    pricingKey  : 'personalFee',
    type        : EFeeType.AuctionFee,
    feeUserType : EFeeUserType.PersonalId,
  },
  dealerAdministrationFee: {
    pricingKey  : 'dealerFee',
    type        : EFeeType.AuctionFee,
    feeUserType : EFeeUserType.DealerId,
  },
  expressRecoveryFees: {
    pricingKey  : 'expressRecoveryFee',
    type        : EFeeType.ExpressRecoveryMonthlyFee,
    feeUserType : EFeeUserType.Other,
  },
  deficiencyTrackingFees: {
    pricingKey  : 'deficiencyTrackingFee',
    type        : EFeeType.DeficiencyTrackingFee,
    feeUserType : EFeeUserType.Other,
  },
  vrmFees: {
    pricingKey  : 'vrmFee',
    type        : EFeeType.VrmFee,
    feeUserType : EFeeUserType.Other,
  },
  srsFees: {
    pricingKey  : 'srsFee',
    type        : EFeeType.SrsFee,
    feeUserType : EFeeUserType.Other,
  },
  reindeerFees: {
    pricingKey  : 'reindeerFee',
    type        : EFeeType.ReindeerFee,
    feeUserType : EFeeUserType.Other,
  },
};

export const USER_ROLE_NAME: Record<EUserRole, string> = {
  [EUserRole.SuperAdmin]             : 'Super Administrator',
  [EUserRole.IntranetUser]           : 'Intranet User',
  [EUserRole.Admin]                  : 'Administrator',
  [EUserRole.Photographer]           : 'Photographer',
  [EUserRole.AuctionManager]         : 'Auction Manager',
  [EUserRole.PurchaseProcessor]      : 'Purchase Processor',
  [EUserRole.RecoveryManager]        : 'Recovery Specialist',
  [EUserRole.CancellationSpecialist] : 'Cancellation Specialist',
};
